import { localStorageHelper } from '../../../../../../utils/localStorageHelper'

// Per-user persistence for the allocation tool's chart-type choice.
// Mirrors the layoutMode helpers in utilityPanel/UtilityPanelProvider
// so the contract feels familiar: validate against a frozen list, fall
// back to the default for missing/invalid values, no-op on missing
// userId. Storage key namespace matches the utility panel's other
// per-user keys (portfolioExplorer.${userId}.utilityPanel.*).

export const CHART_TYPES = Object.freeze(['donut', 'bar', 'treemap'])
export const DEFAULT_CHART_TYPE = 'donut'

function storageKey (userId) {
  return `portfolioExplorer.${userId}.utilityPanel.allocation.chartType`
}

export function loadChartType (userId) {
  if (userId == null) return DEFAULT_CHART_TYPE
  const stored = localStorageHelper.tryLoad(storageKey(userId))
  return CHART_TYPES.includes(stored) ? stored : DEFAULT_CHART_TYPE
}

export function saveChartType (userId, type) {
  if (userId == null) return
  if (!CHART_TYPES.includes(type)) return
  localStorageHelper.tryStore(storageKey(userId), type)
}
